/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Intake_Sex_TitleInputs */

const en_us2_body_assessment_intake_sex_title = /** @type {(inputs: Body_Assessment_Intake_Sex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which term should the calculation use?`)
};

const pt_br2_body_assessment_intake_sex_title = /** @type {(inputs: Body_Assessment_Intake_Sex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual termo o cálculo deve usar?`)
};

const es_419_body_assessment_intake_sex_title = /** @type {(inputs: Body_Assessment_Intake_Sex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué término debe usar el cálculo?`)
};

const pt_pt2_body_assessment_intake_sex_title = /** @type {(inputs: Body_Assessment_Intake_Sex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que termo deve o cálculo usar?`)
};

const fr_fr2_body_assessment_intake_sex_title = /** @type {(inputs: Body_Assessment_Intake_Sex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel terme le calcul doit-il utiliser ?`)
};

const de_de2_body_assessment_intake_sex_title = /** @type {(inputs: Body_Assessment_Intake_Sex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welchen Term soll die Berechnung verwenden?`)
};

const it_it2_body_assessment_intake_sex_title = /** @type {(inputs: Body_Assessment_Intake_Sex_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale termine deve usare il calcolo?`)
};

/**
* | output |
* | --- |
* | "Which term should the calculation use?" |
*
* @param {Body_Assessment_Intake_Sex_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_intake_sex_title = /** @type {((inputs?: Body_Assessment_Intake_Sex_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Intake_Sex_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_intake_sex_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_intake_sex_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_intake_sex_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_intake_sex_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_intake_sex_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_intake_sex_title(inputs)
	return en_us2_body_assessment_intake_sex_title(inputs)
});
export { body_assessment_intake_sex_title as "body-assessment.intake_sex_title" }